import http from '@/services/http';
import changeLogFilters, {
  advancedFilters as changeLogAdvancedFilters,
} from '@/config/filters/changeLog';
import tableHelper from '@/services/tableHelper';

const allChangeLogFilters = [...changeLogFilters, ...changeLogAdvancedFilters];

const changeLog = {
  index(tableFilters, filterStatus, config = {}) {
    const filters = tableHelper.whereFilters(filterStatus, allChangeLogFilters);
    return http.request({
      method: 'get',
      url: '/change-log',
      params: { filter: { ...tableFilters, where: filters } },
      ...config,
    });
  },
  count(filterStatus, config = {}) {
    const where = tableHelper.whereFilters(filterStatus, allChangeLogFilters);
    return http.request({
      method: 'get',
      url: '/change-log/count',
      params: { where },
      ...config,
    });
  },
  exportXlsx(filterStatus) {
    const where = tableHelper.whereFilters(filterStatus, allChangeLogFilters);
    return http.request({
      method: 'get',
      url: `/change-log/export`,
      params: { where },
      responseType: 'blob',
    });
  },
  getDetails(changeLogId) {
    return http.request({
      method: 'get',
      url: `/change-log/${changeLogId}/details`,
    });
  },
};

export default changeLog;
